/* Mobile bag bar on Home / Collection / Search: [- qty +] for the last item added | [Buy now ->] straight to checkout.
   Same look as the product-page sticky bar. Shows while the bag has items. */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var KEY = 'gvLastVariant';
  var J = { Accept: 'application/json' };
  var JH = { Accept: 'application/json', 'Content-Type': 'application/json' };
  var ARROW = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
  var bar, qEl, cart = null, line = null, target = 0, timer = 0, busy = false;
  var nativeFetch = window.fetch.bind(window);

  function getLast() { try { return parseInt(localStorage.getItem(KEY) || '0', 10) || 0; } catch (e) { return 0; } }
  function setLast(id) { try { localStorage.setItem(KEY, String(id)); } catch (e) {} }
  function pickLine(c) {
    var items = (c && c.items) || [];
    if (!items.length) return null;
    var last = getLast();
    for (var i = 0; i < items.length; i++) { if (items[i].variant_id === last) return items[i]; }
    return items[0];
  }
  function build() {
    if (bar) return;
    bar = document.createElement('div');
    bar.className = 'gv-sticky gv-bagbar';
    bar.dataset.state = 'in';
    bar.hidden = true;
    bar.innerHTML =
      '<div class="gv-sticky__qty" role="group" aria-label="Quantity in bag"><button type="button" data-d="-1" aria-label="Remove one">&minus;</button><span data-gv-bagbar-q aria-live="polite">1</span><button type="button" data-d="1" aria-label="Add one more">+</button></div>' +
      '<button type="button" class="gv-sticky__buy" data-gv-bagbar-buy><span>Buy now</span>' + ARROW + '</button>';
    document.body.appendChild(bar);
    qEl = bar.querySelector('[data-gv-bagbar-q]');
    bar.querySelectorAll('[data-d]').forEach(function (b) { b.addEventListener('click', function () { step(parseInt(b.dataset.d, 10)); }); });
    bar.querySelector('[data-gv-bagbar-buy]').addEventListener('click', function () {
      var b = this; b.setAttribute('aria-busy', 'true'); b.querySelector('span').textContent = 'Opening checkout';
      clearTimeout(timer);
      var go = function () { window.location.href = root + 'checkout'; };
      if (line && target !== line.quantity) send().then(go, go); else go();
    });
  }
  function paintCards(variantId, q) {
    document.querySelectorAll('.gv-qa[data-variant="' + variantId + '"]').forEach(function (w) {
      if (q <= 0) { w.dataset.state = 'add'; return; }
      w.dataset.state = 'in';
      var el = w.querySelector('[data-gv-qa-q]'); if (el) el.textContent = q;
    });
  }
  function paintCount(c) {
    var n = c.item_count;
    document.querySelectorAll('[data-gv-cart-count]').forEach(function (e) { e.textContent = n > 99 ? '99+' : String(n); e.hidden = !n; });
  }
  function render(c) {
    cart = c; line = pickLine(c);
    build();
    var show = !!line;
    bar.hidden = !show;
    document.documentElement.classList.toggle('gv-has-sticky', show);
    if (!show) return;
    target = line.quantity;
    if (qEl.textContent !== String(target)) { qEl.textContent = target; if (window.gvTick) window.gvTick(qEl, 0); }
  }
  function load() {
    return nativeFetch(root + 'cart.js', { headers: J, credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); }).then(render).catch(function () {});
  }
  function send() {
    if (!line) return Promise.resolve();
    var key = line.key, vid = line.variant_id, q = target;
    busy = true;
    return nativeFetch(root + 'cart/change.js', { method: 'POST', headers: JH, credentials: 'same-origin', body: JSON.stringify({ id: key, quantity: q }) })
      .then(function (r) { return r.json(); })
      .then(function (c) { busy = false; paintCards(vid, q); paintCount(c); render(c); window.dispatchEvent(new CustomEvent('gv:bag-change')); })
      .catch(function () { busy = false; load(); });
  }
  function step(d) {
    if (!line) return;
    target = Math.max(0, target + d);
    qEl.textContent = target;
    if (window.gvTick) window.gvTick(qEl, d);
    paintCards(line.variant_id, target);
    clearTimeout(timer);
    timer = setTimeout(send, 320);
  }
  if (window.__gvBagbarOn) return;
  window.__gvBagbarOn = true;
  window.__gvBagbarPrev = window.fetch;
  /* listen to every bag change made elsewhere on the page (card ADD, card steppers, pack sheet) */
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = window.__gvBagbarPrev.apply(this, arguments);
    var isAdd = url.indexOf('/cart/add') > -1, isChange = url.indexOf('/cart/change') > -1 || url.indexOf('/cart/update') > -1;
    if (isAdd || isChange) {
      p.then(function (r) {
        if (isAdd && r && r.ok) {
          r.clone().json().then(function (j) {
            var items = j.items || (j.variant_id ? [j] : []);
            if (items.length) setLast(items[items.length - 1].variant_id);
          }).catch(function () {}).then(function () { setTimeout(load, 120); });
        } else if (!busy) setTimeout(load, 120);
      }).catch(function () {});
    }
    return p;
  };
  function init() { load(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('pageshow', function (e) { if (e.persisted) load(); });
})();